
(function ($) {
	$(document).ready(function () {

		$(".accordion-carousel-block").each(function () {

			let carousel_instance = new bootstrap.Carousel($(".accordion-image-carousel", this).get(0));

			$(".carousel-trigger-accordion", this).on("click", ".accordion-button", function (evt) {

				let carousel_slide_to_num = parseInt($(evt.currentTarget).data("slide-carousel-to"));

				if (carousel_slide_to_num > 0) {
					carousel_instance.to(carousel_slide_to_num - 1);
				}

			});

		});

	});
})(jQuery);
